import { type ToastApi, useToast as useRevelioToast } from '@revelio/ui';

/**
 * App-wide toast hook. Call sites go through here rather than importing
 * `@revelio/ui` directly so the implementation stays swappable from one place —
 * this used to pick between the Chakra and `@revelio/ui` toasts depending on the
 * appearance.
 *
 * NOTE: without a `<ToastProvider>` above it this silently no-ops — the store
 * context falls back to a noop, so toasts vanish rather than erroring. Production
 * mounts one in `main.tsx`; a test harness that renders a toasting component
 * needs to wrap it locally, or its toast assertions will fail with nothing in the
 * DOM to explain why. Do NOT add the provider to `libs/core`'s `renderWithData`
 * — core must not depend on ui.
 */
export function useToast(): ToastApi {
  return useRevelioToast();
}
